import { QueryHookResponse } from '../../types/internal';
import { Car, Scalars } from '../../types/generated';
import { useQuery } from '../../utils';
import { showCarQuery } from '../../queries';
import ServiceConfigs from '../../config';

type UseShowCarType = ({
  carId,
  initialData,
}?: {
  carId?: Scalars['ID'];
  initialData?: Car;
}) => QueryHookResponse<Partial<Car>>;

const useShowCar: UseShowCarType = ({ carId, initialData } = {}) =>
  useQuery<Partial<Car>>({
    query: showCarQuery,
    variables: carId ? { carId } : null,
    requestHeaders: { ...ServiceConfigs.getAuthorizationHeader() },
    handler: (res: any) => res.showCar,
    config: { initialData },
  });

export default useShowCar;
